"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

require("./index.css");

var AppBannerSpacer = function () {
  return (0, jsx_runtime_1.jsx)("div", {
    className: "app-banner-spacer"
  }, void 0);
};

exports.default = AppBannerSpacer;